<template>
  <div>
    <navbar-component />
    <div class="bg-container">
      <home-banner-layout :texts="texts" />
      <br />
      <home-catalog-type-layout :texts="texts" />
      <br />
      <home-popular-catalog-layout :texts="texts" />
      <br />
      <home-featured-supplier-layout :texts="texts" />
      <br />
      <home-item-sold-layout :texts="texts" />
      <br />
      <br />
    </div>
    <footer-component />
    <whatsapp-component />
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.home[this.selectLanguage];
  },
  methods: {},
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.home[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-top: 75px;
}
</style>